import { watch } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { WorkerMessage, WorkerMessageDataType } from "@sazka/websocket/notifications/models/worker-message-dto";
import { sendInitMessage, sendStartMessage, sendStopMessage } from "../messages/send-window-message";

const { isLoggedIn } = useNgSession();

const serviceLogin = (comunicationSource: WindowCommunicationSource) => {
    if (isLoggedIn.value) {
        const isLiveDealer = environment.nodeAliasPath === "/live-dealer";
        sendStartMessage(comunicationSource, isLiveDealer);
    } else {
        sendStopMessage(comunicationSource);
    }
};

export const useNotificationEvents = async (
    comunicationSource: WindowCommunicationSource,
    callbackFn: (message: WorkerMessage<WorkerMessageDataType>) => void
) => {
    sendInitMessage(comunicationSource);

    comunicationSource.onmessage = (event: MessageEvent<WorkerMessage<WorkerMessageDataType>>) => {
        callbackFn(event.data);
    };

    await ngFrameworkLoaded();

    watch(
        isLoggedIn,
        () => {
            serviceLogin(comunicationSource);
        },
        { immediate: true }
    );
};
